class RocketSeoDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('.accordion-item');
    this.init();
  }

  init() {
    this.accordionItems.forEach((item) => {
      item.addEventListener('click', function () {
        this.classList.toggle('active');
        this?.querySelector('.accordion-item-body').classList.toggle('hidden');
      });
    });
  }
}

customElements.define('rocket-seo-dropdown', RocketSeoDropdown);

class RocketPopupNewSletter extends HTMLElement {
  constructor() {
    super();

    this.timeOff = parseInt(this.dataset.timeOff);
    this.timeDelayDisplay = parseFloat(this.dataset.timeDelayDisplay);
    this.btnClosePopup = this.querySelector('.rocket-popup-newsletter__close') || null;
    this.popupContent = this.querySelector('.rocket-popup-newsletter') || null;

    this.timeConvert = this.timeDelayDisplay * 60 * 1000;
  }

  connectedCallback() {
    if (this.checkCookie('rocket-popup-newsletter')) {
      document.body.classList.remove('rocket-popup-newsletter--open');
      this.popupContent.classList.add('hidden');
    } else {
      if (this.timeDelayDisplay) {
        setTimeout(() => {
          document.body.classList.add('rocket-popup-newsletter--open');
          this.popupContent.classList.remove('hidden');
        }, this.timeConvert);
      }
    }

    if (this.btnClosePopup) {
      this.btnClosePopup.addEventListener('click', () => {
        this.setTimeCookie('rocket-popup-newsletter', 'closed');

        if (document.body.classList.contains('rocket-popup-newsletter--open')) {
          document.body.classList.remove('rocket-popup-newsletter--open');
          this.popupContent.classList.add('hidden');
        }
      });
    }
  }

  setTimeCookie(name, value) {
    document.cookie = name + '=' + value + ';path=/';
  }

  checkCookie(name) {
    const cookieName = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookiesArray = decodedCookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return true;
      }
    }
    return false;
  }
}

customElements.define('rocket-popup-newsletter', RocketPopupNewSletter);

(function () {
  const hoverClasses = ['hover-top', 'hover-right', 'hover-bottom', 'hover-left', 'in'];

  function handleMouseEnter(e) {
    const btn = e.currentTarget;
    hoverClasses.forEach((cls) => btn.classList.remove(cls));
    btn.classList.add(`hover-${getDirection(e, btn)}`);
    requestAnimationFrame(() => btn.classList.add('in'));
  }

  function handleMouseLeave(e) {
    hoverClasses.forEach((cls) => e.currentTarget.classList.remove(cls));
  }

  // Cache rect values to avoid forced layout on every hover
  const rectCache = new WeakMap();

  function getDirection(e, el) {
    // Use cached rect if available, otherwise get and cache
    let rect = rectCache.get(el);
    if (!rect) {
      rect = el.getBoundingClientRect();
      rectCache.set(el, rect);
    }

    const distTop = e.clientY - rect.top;
    const distBottom = rect.bottom - e.clientY;
    const distLeft = e.clientX - rect.left;
    const distRight = rect.right - e.clientX;

    const minDist = Math.min(distTop, distBottom, distLeft, distRight);

    if (minDist === distTop) return 'top';
    if (minDist === distBottom) return 'bottom';
    if (minDist === distLeft) return 'left';
    if (minDist === distRight) return 'right';
    return 'top';
  }

  function initButtonEffects() {
    if (window.matchMedia('(pointer: fine)').matches === false) {
      return;
    }

    // Cache button elements to avoid repeated queries
    let buttons = null;

    const attachListeners = () => {
      if (!buttons) {
        buttons = document.querySelectorAll('.btn--hover');
      }

      buttons.forEach((btn) => {
        btn.removeEventListener('mouseenter', handleMouseEnter);
        btn.removeEventListener('mouseleave', handleMouseLeave);

        btn.addEventListener('mouseenter', handleMouseEnter, { passive: true });
        btn.addEventListener('mouseleave', handleMouseLeave, { passive: true });
      });
    };

    attachListeners();

    // Update buttons cache when DOM changes (for dynamic content)
    window.initButtonHoverEffects = function () {
      buttons = null; // Reset cache
      attachListeners();
    };
  }
  initButtonEffects();
})();

function handleNewsletterSuccess() {
  const success = new URLSearchParams(window.location.search).get('customer_posted');
  const target = window.location.hash;
  if (success && target) {
    const form = document.querySelector(target);
    form?.querySelector(`.form__message`)?.classList.remove('hidden');
  }
}

handleNewsletterSuccess();

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;
  if (hash === '#ContactFooter') {
    const footer = document.querySelector(hash);
    if (footer) {
      // Replace setTimeout with requestAnimationFrame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
  }

  // Cache header element and debounce scroll updates
  let headerCache = null;
  let scrollTimeout;

  document.addEventListener(
    'scroll',
    () => {
      if (!headerCache) {
        headerCache = document.querySelector('sticky-header');
        if (!headerCache) return;
      }

      // Debounce scroll updates
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        requestAnimationFrame(() => {
          const headerTop = headerCache.getBoundingClientRect().top;
          document.documentElement.style.setProperty('--header-height-scrolling', `${headerTop}px`);
        });
      }, 16); // ~60fps
    },
    { passive: true }
  );

  // Mega menu desktop toggle
  const submenu = document.querySelectorAll('[data-transform-menu]');
  if (submenu.length > 0) {
    submenu.forEach((menu) => {
      menu.addEventListener('click', (e) => {
        e.preventDefault();
        const container = e.currentTarget.closest('.mega-menu__content__container');
        if (!container) return;

        requestAnimationFrame(() => {
          const activeItem = container.querySelector('[data-transform-menu].active');
          const inactiveItem = container.querySelector('[data-transform-menu]:not(.active)');
          const activeList = container.querySelector('.mega-menu__list:not(.hidden)');
          const hiddenList = container.querySelector('.mega-menu__list.hidden');

          if (activeItem) activeItem.classList.remove('active');
          if (inactiveItem) inactiveItem.classList.add('active');
          if (activeList) activeList.classList.add('hidden');
          if (hiddenList) hiddenList.classList.remove('hidden');
        });
      });
    });
  }

  // Mega menu mobile toggle
  const submenuMb = document.querySelectorAll('[data-transform-menu-mb]');
  if (submenuMb.length > 0) {
    submenuMb.forEach((menu) => {
      menu.addEventListener('click', (e) => {
        e.preventDefault();
        const currentTarget = e.currentTarget;
        requestAnimationFrame(() => {
          currentTarget.closest('.mega-menu__category-item-sub')?.classList.toggle('is_active');
        });
      });
    });
  }
});
